import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=cad4bcca&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=cad4bcca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad4bcca",
  null
  
)

export default component.exports